module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAKCAYAAACE2W/HAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAALEgAACxIB0t1+/AAAABV0RVh0Q3JlYXRpb24gVGltZQAxLzMwLzE05s6mdgAAABx0RVh0U29mdHdhcmUAQWRvYmUgRmlyZXdvcmtzIENTNui8sowAAABESURBVCiRY9yy9dl/BggQ9PGW+oDExwuYiFGEDbAwMDAIMjAwMPz79+8jzGaa2/iegYGBgYmJSZCBgeEDjE9TG4e7HwGZtRZOqXjGmQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/api/select_fromList_normal.png
// module id = 16
// module chunks = 0